// extracted by mini-css-extract-plugin
export default {"butt":"back_butt__nl9Dc"};